import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { SchoolClass } from 'src/modules/enaio-certificates/shared/school-class.model';
import { Utils } from 'src/modules/utils/shared/utils';
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { EnaioCertificatesTools } from '../../shared/enaio-certificates-tools';

@Component({
    selector: 'enaio-certificates-main',
    templateUrl: './certificates-main.component.html',
    styleUrls: []
})
export class CertificatesMainComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    schoolClasses: SchoolClass[] = [];
    isHalfYear: boolean;
    userName = "";
    isAdmin = false;

    async initParams(): Promise<boolean> {
        this.isHalfYear = EnaioCertificatesTools.getCurrentIsHalfYear();
        this.isAdmin = this.service.isAdminForCertificates();
        this.app.updateNavigation("Zeugnisse", [this.service.getHomeCertificates()]);
        this.schoolClasses = (await this.service.restGetSchoolClasses(EnaioCertificatesTools.getCurrentSchoolYear())).filter(sc => sc.isForCertificates());
        this.userName = this.app.getUserName();
        return true;
    }

    getExistingGrades(): number[] {
        return Utils.arrayGetUnique(this.schoolClasses.map(sc => sc.grade));
    }

    async adminClick(): Promise<void> {
        await this.app.navigateTo(["/enaio-certificates", "globalsettings"]);
    }
}
